document.oncontextmenu = onContextMenu

function onContextMenu(e = window.event) {
  const target = e.srcElement || e.target

  // Prevent context menu for image elements
  if (target.nodeName === 'IMG') return false
}
